class LqdGlobalHandler extends elementorModules.frontend.handlers.Base {
  
  onInit(...args) {
    
    this.getModelSetting();

    if ( ! this.modelSetting ) return;

    this.customAnimationsOpts = false;
    this.customAnimationsPlayBtn = false;

    this.handleCustomAnimationApply = liquidDebounce(this.handleCustomAnimationApply.bind(this), 1000, true);
    
    super.onInit(...args);

    this.handleDestroy();
    
    this.handleParallaxInit();
    this.handleCustomAnimationInit();

  }

  // bindEvents() {

  //   if ( elementorFrontend.isEditMode() && this.modelSetting ) {
  //     elementor.channels.editor.on( 'lqd_ca_apply', this.handleCustomAnimationApply);
  //   }

  // }

  // unbindEvents() {

  //   if ( elementorFrontend.isEditMode() ) {
  //     elementor.channels.editor.off( 'lqd_ca_apply', this.handleCustomAnimationApply);
  //   }

  // }

  getModelSetting() {

    this.modelSetting = elementorFrontend.config.elements.data[this.getModelCID()];

  }

  getElementPluginData(pluginData) {
    return this.$element.data(pluginData);
  }

  onElementChange(prop) {

    this.getModelSetting();

    if ( prop === 'lqd_parallax' ) {
      this.handleParallaxInit();
    }
    if (
      prop.startsWith('lqd_parallax_from_') ||
      prop.startsWith('lqd_parallax_to_') ||
      prop === 'lqd_parallax_settings_perspective' ||
      prop === 'lqd_parallax_settings_ease'
    ) {
      this.handleParallaxFromToUpdate();
    }
    if (
      prop === 'lqd_parallax_settings_duration' ||
      prop === 'lqd_parallax_settings_trigger' ||
      prop === 'lqd_parallax_settings_trigger_start' ||
      prop === 'lqd_parallax_settings_trigger_end'
    ) {
      this.handleParallaxSettingsUpdate();
    }

    if ( prop === 'lqd_custom_animation' ) {
      this.getCustomAnimationsOpts();
      this.handleCustomAnimationInit();
      // this.handleApplyBtnVisibility('disable');
    }
    if (
      prop.startsWith('lqd_ca_settings_') ||
      prop.startsWith('lqd_ca_from_') ||
      prop.startsWith('lqd_ca_to_')
    ) {
      this.getCustomAnimationsOpts();
      this.handleCustomAnimationDestroy();
      // this.handleApplyBtnVisibility('enable');
    }

  }

  handleParallaxInit() {
    
    if ( this.modelSetting.get('lqd_parallax') === 'yes' ) {
      this.initParallax();
    } else {
      this.handleParallaxDestroy();
    }

  }

  initParallax() {

    const parallaxFromTo = this.getParallaxFromTo();
    const parallaxOptions = this.getParallaxSettings();

    this.$element.liquidParallax(parallaxOptions, parallaxFromTo.fromVals, parallaxFromTo.toVals);

  }

  getParallaxFromTo() {

    const parallaxVals = this.getAnimationValues('parallax');

    const perspective = this.modelSetting.get('lqd_parallax_settings_perspective');
    const ease = this.modelSetting.get('lqd_parallax_settings_ease');

    if ( perspective !== '' && perspective != null && perspective.size !== '' ) {
      parallaxVals.from.transformPerspective = `${perspective.size}${perspective.unit}`;
    }

    if ( ease !== '' && ease != null ) {
      parallaxVals.to.ease = ease;
    }

    return {
      fromVals: parallaxVals.from,
      toVals: parallaxVals.to
    }

  }

  getParallaxSettings() {

    const parallaxOptions = {
      start: 'top bottom',
      end: 'bottom top'
    };

    if ( this.modelSetting.get('lqd_parallax_settings_trigger') !== 'custom' ){
      parallaxOptions.start = this.modelSetting.get('lqd_parallax_settings_trigger');
      const settingsDuration = this.modelSetting.get('lqd_parallax_settings_duration');
      if ( settingsDuration && settingsDuration !== '' ) {
        const dur = settingsDuration.size >= 0 ? `+=${Math.abs(settingsDuration.size)}${settingsDuration.unit}` : `-=${Math.abs(settingsDuration.size)}${settingsDuration.unit}`;
        parallaxOptions.end = `bottom${dur} top`;
      }
    } else {
      if ( this.modelSetting.get('lqd_parallax_settings_trigger_start') !== '' ) {
        parallaxOptions.start = this.modelSetting.get('lqd_parallax_settings_trigger_start');
      }
      if ( this.modelSetting.get('lqd_parallax_settings_trigger_end') !== '' ) {
        parallaxOptions.end = this.modelSetting.get('lqd_parallax_settings_trigger_end');
      }
    }
    return parallaxOptions;

  }

  getAnimationValues(effect = 'parallax') {

    const values = {
      from: {},
      to: {}
    };

    const fromX = this.modelSetting.get(`lqd_${effect}_from_x`);
    const fromY = this.modelSetting.get(`lqd_${effect}_from_y`);
    const fromZ = this.modelSetting.get(`lqd_${effect}_from_z`);

    const fromScaleX = this.modelSetting.get(`lqd_${effect}_from_scaleX`).size;
    const fromScaleY = this.modelSetting.get(`lqd_${effect}_from_scaleY`).size;

    const fromRotationX = this.modelSetting.get(`lqd_${effect}_from_rotationX`).size;
    const fromRotationY = this.modelSetting.get(`lqd_${effect}_from_rotationY`).size;
    const fromRotationZ = this.modelSetting.get(`lqd_${effect}_from_rotationZ`).size;

    const fromOpacity = this.modelSetting.get(`lqd_${effect}_from_opacity`).size;

    const fromOriginX = this.modelSetting.get(`lqd_${effect}_from_transformOriginX`);
    const fromOriginY = this.modelSetting.get(`lqd_${effect}_from_transformOriginY`);
    const fromOriginZ = this.modelSetting.get(`lqd_${effect}_from_transformOriginZ`);

    const toX = this.modelSetting.get(`lqd_${effect}_to_x`);
    const toY = this.modelSetting.get(`lqd_${effect}_to_y`);
    const toZ = this.modelSetting.get(`lqd_${effect}_to_z`);

    const toScaleX = this.modelSetting.get(`lqd_${effect}_to_scaleX`).size;
    const toScaleY = this.modelSetting.get(`lqd_${effect}_to_scaleY`).size;

    const toRotationX = this.modelSetting.get(`lqd_${effect}_to_rotationX`).size;
    const toRotationY = this.modelSetting.get(`lqd_${effect}_to_rotationY`).size;
    const toRotationZ = this.modelSetting.get(`lqd_${effect}_to_rotationZ`).size;

    const toOpacity = this.modelSetting.get(`lqd_${effect}_to_opacity`).size;

    const toOriginX = this.modelSetting.get(`lqd_${effect}_to_transformOriginX`);
    const toOriginY = this.modelSetting.get(`lqd_${effect}_to_transformOriginY`);
    const toOriginZ = this.modelSetting.get(`lqd_${effect}_to_transformOriginZ`);

    if ( (fromX.size !== toX.size) || (fromX.unit !== toX.unit) ) {
      values.from.x = `${fromX.size}${fromX.unit}`;
      values.to.x = `${toX.size}${toX.unit}`;
    }
    if ( (fromY.size !== toY.size) || (fromY.unit !== toY.unit) ) {
      values.from.y = `${fromY.size}${fromY.unit}`;
      values.to.y = `${toY.size}${toY.unit}`;
    }
    if ( (fromZ.size !== toZ.size) || (fromZ.unit !== toZ.unit) ) {
      values.from.z = `${fromZ.size}${fromZ.unit}`;
      values.to.z = `${toZ.size}${toZ.unit}`;
    }

    if ( fromScaleX !== toScaleX ) {
      values.from.scaleX = fromScaleX;
      values.to.scaleX = toScaleX;
    }
    if ( fromScaleY !== toScaleY ) {
      values.from.scaleY = fromScaleY;
      values.to.scaleY = toScaleY;
    }

    if ( fromRotationX !== toRotationX ) {
      values.from.rotationX = fromRotationX;
      values.to.rotationX = toRotationX;
    }
    if ( fromRotationY !== toRotationY ) {
      values.from.rotationY = fromRotationY;
      values.to.rotationY = toRotationY;
    }
    if ( fromRotationZ !== toRotationZ ) {
      values.from.rotationZ = fromRotationZ;
      values.to.rotationZ = toRotationZ;
    }

    if ( fromOpacity !== toOpacity ) {
      values.from.opacity = fromOpacity;
      values.to.opacity = toOpacity;
    }
    
    values.from.transformOrigin = `${fromOriginX.size}${fromOriginX.unit} ${fromOriginY.size}${fromOriginY.unit} ${fromOriginZ.size}${fromOriginZ.unit}`;
    values.to.transformOrigin = `${toOriginX.size}${toOriginX.unit} ${toOriginY.size}${toOriginY.unit} ${toOriginZ.size}${toOriginZ.unit}`;

    if ( values.from.transformOrigin == values.to.transformOrigin ) {
      delete values.from.transformOrigin;
      delete values.to.transformOrigin;
    }

    return values;

  }

  handleParallaxFromToUpdate() {

    const parallaxPluginData = this.getElementPluginData('plugin_liquidParallax');

    const parallaxFromTo = this.getParallaxFromTo();

    parallaxPluginData.parallaxTimeline.set(parallaxPluginData.parallaxElement, {clearProps: 'all'});
    parallaxPluginData.parallaxTimeline.clear();

    parallaxPluginData.parallaxTimeline.fromTo(parallaxPluginData.parallaxElement,
      parallaxFromTo.fromVals,
      parallaxFromTo.toVals
    );

    parallaxPluginData.parallaxFromOptions = parallaxFromTo.fromVals;
    parallaxPluginData.parallaxToOptions = parallaxFromTo.toVals;
    parallaxPluginData.options.ease = parallaxFromTo.toVals.ease;

    parallaxPluginData.ST.refresh();
    parallaxPluginData.parallaxTimeline.scrollTrigger.refresh();

  }

  handleParallaxSettingsUpdate() {

    const parallaxPluginData = this.getElementPluginData('plugin_liquidParallax');

    const parallaxSettings = this.getParallaxSettings();

    parallaxPluginData.options.start = parallaxSettings.start;
    parallaxPluginData.options.end = parallaxSettings.end;
    
    parallaxPluginData.ST.refresh();
    parallaxPluginData.parallaxTimeline.scrollTrigger.refresh();

  }

  handleCustomAnimationInit() {

    if ( this.modelSetting.get('lqd_custom_animation') === 'yes' ) {
      this.getCustomAnimationsOpts();
      this.initCustomAnimation();
    } else {
      this.handleCustomAnimationDestroy();
    }

  }

  handleCustomAnimationApply(event) {

    const elementView = elementor.getPanelView().getCurrentPageView().getOption( 'editedElementView' );

    if ( ! event || ! event.options || ! elementView || ! elementView.model ) return;

    if ( elementView.model.cid === event.options.element.model.cid ) {
      this.handleCustomAnimationDestroy();
      this.getCustomAnimationsOpts();
      this.initCustomAnimation();
      // this.handleApplyBtnVisibility('disable');
    }

  }

  getCustomAnimationsFromTo() {

    const caValues = this.getAnimationValues('ca');

    return {
      fromVals: caValues.from,
      toVals: caValues.to
    }

  }

  getCustomAnimationsSettings() {

    const customAnimationsSettings = {};

    const ease = this.modelSetting.get('lqd_ca_settings_ease');
    const direction = this.modelSetting.get('lqd_ca_settings_direction');
    const duration = this.modelSetting.get('lqd_ca_settings_duration');
    const stagger = this.modelSetting.get('lqd_ca_settings_stagger');
    const startDelay = this.modelSetting.get('lqd_ca_settings_start_delay');

    if ( ease ) {
      customAnimationsSettings.ease = ease;
    }
    if ( direction ) {
      customAnimationsSettings.direction = direction;
    }
    if ( duration ) {
      customAnimationsSettings.duration = duration.size * 1000;
    }
    if ( stagger ) {
      customAnimationsSettings.delay = stagger.size * 1000;
    }
    if ( startDelay ) {
      customAnimationsSettings.startDelay = startDelay.size * 1000;
    }

    return customAnimationsSettings;

  }

  getCustomAnimationsOpts() {

    const customAnimationsSettings = this.getCustomAnimationsSettings();
    const customAnimationsFromTo = this.getCustomAnimationsFromTo();
    const elementType = this.getElementType();
    const widgetType = this.getWidgetType();
    const animationTargets = [];
    let addChildTimelines = false;

    // if ( elementType === 'column' || elementType === 'widget' ) {
    //   addChildTimelines = true;
    // }

    if ( elementType === 'section' ) {

      animationTargets.push(':scope > .elementor-container > .elementor-column');

    } else if ( elementType === 'container' )  {

      const targetsOpt = this.modelSetting.get('lqd_ca_targets');
      const includeInnerContent = this.modelSetting.get('lqd_ca_include_inner_content');

      if ( targetsOpt === 'contents' ) {
        animationTargets.push(':scope > .elementor-element > .elementor-widget-container');
        animationTargets.push(':scope > .elementor-widget-hub_fancy_heading .lqd-split-lines .lqd-lines .split-inner');
        animationTargets.push(':scope > .elementor-widget-hub_fancy_heading .lqd-split-words .lqd-words .split-inner');
        animationTargets.push(':scope > .elementor-widget-hub_fancy_heading .lqd-split-chars .lqd-chars .split-inner');
        animationTargets.push(':scope > .elementor-widget-ld_custom_menu .lqd-fancy-menu > ul > li');
        if ( includeInnerContent === 'yes' ) {
          animationTargets.push(':scope .e-container:not([data-parallax]) > .elementor-element > .elementor-widget-container');
          animationTargets.push(':scope .e-container:not([data-parallax]) > .elementor-widget-hub_fancy_heading .lqd-split-lines .lqd-lines .split-inner');
          animationTargets.push(':scope .e-container:not([data-parallax]) > .elementor-widget-hub_fancy_heading .lqd-split-words .lqd-words .split-inner');
          animationTargets.push(':scope .e-container:not([data-parallax]) > .elementor-widget-hub_fancy_heading .lqd-split-chars .lqd-chars .split-inner');
          animationTargets.push(':scope .e-container:not([data-parallax]) > .elementor-widget-ld_custom_menu .lqd-fancy-menu > ul > li');
        }
      } else {
        animationTargets.push(':scope > .e-container');
      }

    } else if ( elementType === 'column' ) {

      animationTargets.push(':scope > .elementor-widget-wrap > .elementor-element > .elementor-widget-container');
      animationTargets.push(':scope > .elementor-widget-wrap > .elementor-section > .elementor-container > .elementor-column > .elementor-widget-wrap > .elementor-element:not(.lqd-el-has-inner-anim) > .elementor-widget-container');
      animationTargets.push(':scope > .elementor-widget-wrap > .elementor-widget-hub_fancy_heading .lqd-split-lines .lqd-lines .split-inner');
      animationTargets.push(':scope > .elementor-widget-wrap > .elementor-widget-hub_fancy_heading .lqd-split-words .lqd-words .split-inner');
      animationTargets.push(':scope > .elementor-widget-wrap > .elementor-widget-hub_fancy_heading .lqd-split-chars .lqd-chars .split-inner');
      animationTargets.push(':scope > .elementor-widget-wrap > .elementor-widget-ld_custom_menu .lqd-fancy-menu > ul > li');

    } else if ( elementType === 'widget' ) {

      if ( widgetType === 'hub_fancy_heading' && this.getElementSettings('enable_split') == 'true' ) {

        const splitType = this.getElementSettings('split_type');

        if ( splitType === 'lines' ) {
          animationTargets.push('.lqd-split-lines .lqd-lines .split-inner');
        } else if ( splitType === 'words' ) {
          animationTargets.push('.lqd-split-words .lqd-words .split-inner');
        } else if ( splitType === 'chars, words' ) {
          animationTargets.push('.lqd-split-chars .lqd-chars .split-inner');
        }

      } else if ( widgetType === 'ld_custom_menu' ) {

        animationTargets.push(':scope .lqd-fancy-menu > ul > li');
        
      } else if ( widgetType === 'ld_carousel' || widgetType === 'ld_testimonial_carousel' ) {

        animationTargets.push('[data-lqd-flickity] > .flickity-viewport > .flickity-slider > .carousel-item > .carousel-item-inner');
        
      } else {

        animationTargets.push(':scope > .elementor-widget-container');

      }
    }

    const opts = {
      addChildTimelines,
      // addPerspective: false,
      animationTarget: animationTargets.join(', '),
      ...customAnimationsSettings,
      initValues: customAnimationsFromTo.fromVals,
      animations: customAnimationsFromTo.toVals
    }
    
    this.$element.attr('data-ca-options', JSON.stringify(opts));

    this.customAnimationsOpts = opts;

  }

  initCustomAnimation() {

    this.$element.liquidCustomAnimations(this.customAnimationsOpts);

  }

  onDestroy() {

    this.handleDestroy();

    super.onDestroy();

  }

  handleDestroy() {

    this.handleParallaxDestroy();
    this.handleCustomAnimationDestroy();

  }

  handleParallaxDestroy() {
    
    const parallaxData = this.getElementPluginData('plugin_liquidParallax');

    if ( parallaxData ) {
      parallaxData.destroy();
    }

  }

  handleCustomAnimationDestroy() {

    const customAnimationData = this.$element.data('plugin_liquidCustomAnimations');

    if ( customAnimationData ) {
      customAnimationData.destroy();
    }

  }

  handleApplyBtnVisibility(stats) {

    this.customAnimationsPlayBtn = elementor.getPanelView().getCurrentPageView().getControlViewByName('lqd_ca_control_apply').$el.find('.elementor-button');

    if ( ! this.customAnimationsPlayBtn ) return;

    if ( stats === 'disable' ) {
      this.customAnimationsPlayBtn
        .addClass('elementor-disabled')
        .attr('disabled', true);
    } else if ( stats === 'enable' ) {
      this.customAnimationsPlayBtn
        .removeClass('elementor-disabled')
        .attr('disabled', false);
    }

  }
  
}

jQuery(window).on('elementor/frontend/init', () => {

  const $ = elementorFrontend.elements.window.jQuery;

  const liquidCaApply = liquidThrottle((event) => {

    // const $btn = event.$el.find('.elementor-button');
    const $activeElement = $(event.options.element.el);
    const options = JSON.parse($activeElement.attr('data-ca-options'));
    const caData = $activeElement.data('plugin_liquidCustomAnimations');

    if ( caData && caData.animationsTimeline && ! caData.animationsTimeline.isActive() ) {
      caData.destroy();
    }

    $activeElement.liquidCustomAnimations(options);

    // console.log($activeElement.data('plugin_liquidCustomAnimations'));

  }, 300);


  elementor.channels.editor.on( 'lqd_ca_apply', liquidCaApply);

  // elementor.channels.editor.on( 'lqd_ca_playpause', event => {

  //   console.log(event);

  //   const $btn = event.$el.find('.elementor-button');
  //   const $activeElement = $(event.options.element.el);
  //   const options = JSON.parse($activeElement.attr('data-ca-options'));
  //   let caData = $activeElement.data('plugin_liquidCustomAnimations');
    
  //   if ( caData ) {
      
  //     caData.destroy();
      
  //     $activeElement.liquidCustomAnimations(options);

  //     caData = $activeElement.data('plugin_liquidCustomAnimations');

      // const {animationsTimeline} = caData;
      // const animationsPlaying = animationsTimeline.isActive();

      // console.log(animationsPlaying);

      // if ( animationsPlaying ) {
      //   caData.animationsTimeline.pause();
      // } else {
      //   if ( animationsTimeline.progress() === 1 ) {
      //     caData.animationsTimeline.restart();
      //   } else {
      //     caData.animationsTimeline.play();
      //   }
      // }
      
      // $btn.toggleClass('lqd-animations-playing');

    // }

  // });

})

export default ($element) => {
  elementorFrontend.elementsHandler.addHandler( LqdGlobalHandler, { $element } );
};